// extracted by mini-css-extract-plugin
module.exports = {"chart_start_color":"#622AAE","main_color":"#308CF6","palletePrimary":"#fff"};